<div class="columns">
  <div class="column">
    <div class="info__box p-0" style="border-radius: 25px">
      <div class="columns">
        <div class="column">
          <div class="info__box__head p-4 mb-4">
              <span class="is-5 is-bold color-darkblue is-size-5 mb-4">
                <span class="mr-2">
                  <fa-icon [icon]="faInfoCircle"></fa-icon>
                </span>
                Hinweis:
              </span>
          </div>
          <div class="info__box__body">
            <p class="pl-4 pr-4">
              Für den Nachweis des berechtigten Interesses benötigten wir Ihre Bevollmächtigung zu Beantragung bei den
              zuständigen Behörden/Ämtern. Hierzu gibt es zwei gängige Szenarien, Details entnehmen Sie bitte unserem
              <span>
                  <a href="assets/files/Informationsblatt_Vollmachten.pdf" class="is-lightblue"
                     download="DocEstate - Informationsblatt Vollmachten.pdf">
                    Informationsblatt.
                  </a>
              </span>
            </p>

            <p class="info-spacer mb-4 mt-4"></p>

            <p class="pl-4 pr-4">
              <span class="is-bold mt-3">Sollten Sie Eigentümer/Eigentümerin/Eigentümerpartei sein, benötigten wir eine Vollmacht:</span>
              <br>
              <br>
              <span class="ml-4"><u>Direktbevollmächtigung, der schnellste Weg</u>: (1) Eigentümerpartei an Vertreter + DocEstate GmbH</span>
            </p>

            <p class="indent pl-0 pr-4 mt-4">
              <i>Liegt Ihnen als Vertreter der Eigentümerpartei bereits eine unterschriebene Vollmacht vor und soll
                diese nicht auch auf die DocEstate GmbH ausgestellt werden, nutzen Sie bitte die vorgestellte
                Alternative und speichern unser Template für künftige Fälle.</i>
            </p>

            <br>
            <p class="pl-4 pr-4">
                <span class="is-bold">Sollten sie selbst Vertreter (z.B. Asset Manager, Jurist oder Makler) sein, benötigen wir zwei
                Vollmachten:</span>
              <br>
              <br>
              <span class="ml-4"><u>Unterbevollmächtigung, die beste Alternative</u>: (1) Eigentümerpartei an Vertreter und (2) Vertreter an DocEstate GmbH</span>
            </p>
            <br>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
